import { inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { first, tap } from 'rxjs';
import { fetchDataTypes } from './data-type.actions';
import { selectDataTypes } from './data-type.selectors';

export const dataTypeResolver = () => {
  const store = inject(Store);
  return store.pipe(
    select(selectDataTypes),
    tap((dataTypes) => {
      if (!dataTypes || dataTypes.length === 0) {
        store.dispatch(fetchDataTypes());
      }
    }),
    first()
  );
};
